const blockTransformer = require('./block');
const isResolvedCollection = require('../contentful/is-resolved-collection');
const isResolvedResource = require('../contentful/is-resolved-resource');
const makeTransformer = require('./make');
const dealerTransformer = require('./dealer');
const modelTransformer = require('./model');
const leadSchemaTransformer = require('./leadSchema');
const asset = require('./asset');

const createEntryLink = (entry) => {
  return {
    sys: {
      type: 'Link',
      linkType: 'Entry',
      id: entry.id
    }
  };
};

const createAssetLink = (asset) => {
  return {
    sys: {
      type: 'Link',
      linkType: 'Asset',
      id: asset.id
    }
  };
};

module.exports = {
  contentfulToInternal(article) {
    const result = {
      id: article.sys.id,
      published: Boolean(article.sys.publishedVersion),
      updated: article.sys.publishedVersion && article.sys.version > article.sys.publishedVersion + 1,
      draft: !article.sys.publishedVersion,
      archived: Boolean(article.sys.archivedVersion),
      listImage: null,
      mainImage: null,
      icon: (article.fields.icon ? article.fields.icon['nb-NO'] : ''),
      title: '',
      url: (article.fields.url ? article.fields.url['nb-NO'] : ''),
      priority: 0,
      summary: '',
      caption: '',
      centerAlign: false,
      bodytext: [],
      metadata: {},
      generationLink: {},
      makes: [],
      // models: [],
      pages: (article.fields.pages ? article.fields.pages['nb-NO'] : []),
      pagesOptions: [],
      myPageCategories: (article.fields.myPageCategories ? article.fields.myPageCategories['nb-NO'] : []),
      myPageCategoriesOptions: [],
      dealers: [],
      fromDate: null,
      toDate: null,
      ctaForm: (article.fields.ctaForm ? article.fields.ctaForm['nb-NO'] : ''),
      ctaFormExt: null,
      ctaTitle: (article.fields.ctaTitle ? article.fields.ctaTitle['nb-NO'] : ''),
      ctaText: (article.fields.ctaText ? article.fields.ctaText['nb-NO'] : ''),
      ctaUrl: (article.fields.ctaUrl ? article.fields.ctaUrl['nb-NO'] : ''),
      ctaButtonText: (article.fields.ctaButtonText ? article.fields.ctaButtonText['nb-NO'] : ''),
      ctaAlign: (article.fields.ctaAlign ? article.fields.ctaAlign['nb-NO'] : ''),
      criticalBannerArticle: (article.fields.criticalBannerArticle ? article.fields.criticalBannerArticle['nb-NO'] : false),
      criticalBannerText: (article.fields.criticalBannerText ? article.fields.criticalBannerText['nb-NO'] : ''),
      motorforum: (article.fields.motorforum ? article.fields.motorforum['nb-NO'] : false),
      contentType: 'articlecollection'
    };

    if (article.sys && article.sys.contentType && article.sys.contentType.fields) {
      // populate options
      const pageOptions = article.sys.contentType.fields.find((field) => {
        return field.id === 'pages';
      });
      if (pageOptions) {
        result.pagesOptions = pageOptions.items.validations[0].in.filter((option) => {
          // Use "Motorforum *" options for motorforum articles, and others for non mf articles
          if (article.fields.motorforum && article.fields.motorforum['nb-NO']) {
            return option.startsWith('Motorforum ');
          }

          return !option.startsWith('Motorforum ');
        });
      }
      const MyPageSectionsOptions = article.sys.contentType.fields.find((field) => {
        return field.id === 'myPageCategories';
      });
      if (MyPageSectionsOptions) {
        result.myPageCategoriesOptions = MyPageSectionsOptions.items.validations[0].in;
      }
    }

    if (article.fields.title && article.fields.title['nb-NO']) {
      result.title = article.fields.title['nb-NO'];
    } else if (article.fields.name && article.fields.name['nb-NO']) {
      result.title = article.fields.name['nb-NO'];
    }

    // Make links:
    result.makeIds = article.fields.makes ? article.fields.makes['nb-NO'].map((d) => d.sys.id) : [];
    if (article.fields.makes && article.fields.makes['nb-NO'] && isResolvedCollection(article.fields.makes['nb-NO'])) {
      result.makes = article.fields.makes['nb-NO'].map(makeTransformer.contentfulToInternal);
    }

    // Dealer links:
    result.dealerIds = article.fields.dealers ? article.fields.dealers['nb-NO'].map((d) => d.sys.id) : [];
    if (article.fields.dealers && article.fields.dealers['nb-NO'] && isResolvedCollection(article.fields.dealers['nb-NO'])) {
      result.dealers = article.fields.dealers['nb-NO'].map(dealerTransformer.contentfulToInternal);
    }

    // Models links:
    if (article.fields.models && article.fields.models['nb-NO'] && isResolvedCollection(article.fields.models['nb-NO'])) {
      result.models = article.fields.models['nb-NO'].map(modelTransformer.contentfulToInternal);
    }

    if (article.fields.summary && article.fields.summary['nb-NO']) {
      result.summary = article.fields.summary['nb-NO'];
    }

    if (article.fields.caption && article.fields.caption['nb-NO']) {
      result.caption = article.fields.caption['nb-NO'];
    }

    if (article.fields.priority && article.fields.priority['nb-NO']) {
      result.priority = parseInt(article.fields.priority['nb-NO'], 10);
    }

    if (article.fields.centerAlign && article.fields.centerAlign['nb-NO']) {
      result.centerAlign = article.fields.centerAlign['nb-NO'];
    }

    if (article.fields.metadata && article.fields.metadata['nb-NO']) {
      result.metadata = article.fields.metadata['nb-NO'];
    }

    if (article.fields.generationLink && article.fields.generationLink['nb-NO']) {
      result.generationLink = article.fields.generationLink['nb-NO'];
    }

    if (article.fields.bodytext && article.fields.bodytext['nb-NO'] && isResolvedCollection(article.fields.bodytext['nb-NO'])) {
      result.bodytext = article.fields.bodytext['nb-NO'].map(blockTransformer.contentfulToInternal);
    }

    if (article.fields.listImage && article.fields.listImage['nb-NO'] && isResolvedResource(article.fields.listImage['nb-NO'])) {
      result.listImage = asset.contentfulToInternal(article.fields.listImage['nb-NO']);
    }
    if (article.fields.mainImage && article.fields.mainImage['nb-NO'] && isResolvedResource(article.fields.mainImage['nb-NO'])) {
      result.mainImage = asset.contentfulToInternal(article.fields.mainImage['nb-NO']);
    }

    if (article.fields.fromDate && article.fields.fromDate['nb-NO']) {
      result.fromDate = new Date(article.fields.fromDate['nb-NO']);
    }

    if (article.fields.toDate && article.fields.toDate['nb-NO']) {
      result.toDate = new Date(article.fields.toDate['nb-NO']);
    }

    if (article.fields.ctaFormExt && article.fields.ctaFormExt['nb-NO'] && isResolvedResource(article.fields.ctaFormExt['nb-NO'])) {
      result.ctaFormExt = leadSchemaTransformer.contentfulToInternal(article.fields.ctaFormExt['nb-NO']);
    }

    // Update model status based on content blocks status
    result.bodytext.forEach((rd) => {
      if (!rd.published || rd.updated) {
        result.updated = true;
      }
    });

    return result;
  },

  internalToContentful(article) {
    const result = {
      fields: {
        listImage: null,
        mainImage: null,
        centerAlign: null,
        ctaForm: null,
        ctaTitle: null,
        ctaText: null,
        ctaUrl: null,
        ctaButtonText: null,
        ctaAlign: null,
        criticalBannerArticle: null,
        criticalBannerText: null,
        motorforum: null,
        generationLink: null
      }
    };

    if (typeof article.title !== 'undefined') {
      result.fields.title = {
        'nb-NO': article.title
      };
    }

    if (typeof article.priority !== 'undefined') {
      result.fields.priority = {
        'nb-NO': parseInt(article.priority, 10)
      };
    }

    if (typeof article.url !== 'undefined') {
      result.fields.url = {
        'nb-NO': article.url
      };
    }

    if (typeof article.summary !== 'undefined') {
      result.fields.summary = {
        'nb-NO': article.summary
      };
    }

    if (typeof article.icon !== 'undefined') {
      result.fields.icon = {
        'nb-NO': article.icon
      };
    }

    if (typeof article.caption !== 'undefined') {
      result.fields.caption = {
        'nb-NO': article.caption
      };
    }

    if (typeof article.centerAlign !== 'undefined') {
      result.fields.centerAlign = {
        'nb-NO': article.centerAlign === true
      };
    }

    if (typeof article.makes !== 'undefined') {
      result.fields.makes = {
        'nb-NO': article.makes ? article.makes.map(createEntryLink) : null
      };
    }

    if (typeof article.models !== 'undefined') {
      result.fields.models = {
        'nb-NO': article.models ? article.models.map(createEntryLink) : null
      };
    }

    // Content blocks for the article
    if (typeof article.bodytext !== 'undefined') {
      result.fields.bodytext = {
        'nb-NO': article.bodytext ? article.bodytext.map(createEntryLink) : null
      };
    }

    if (typeof article.listImage !== 'undefined' && article.listImage !== null) {
      result.fields.listImage = {
        'nb-NO': createAssetLink(article.listImage)
      };
    }
    if (typeof article.mainImage !== 'undefined' && article.mainImage !== null) {
      result.fields.mainImage = {
        'nb-NO': createAssetLink(article.mainImage)
      };
    }

    if (typeof article.metadata !== 'undefined') {
      result.fields.metadata = {
        'nb-NO': article.metadata
      };
    }

    if (typeof article.generationLink !== 'undefined' && (Object.keys(article.generationLink).length > 0)) {
      result.fields.generationLink = {
        'nb-NO': article.generationLink
      };
    }

    if (typeof article.pages !== 'undefined') {
      result.fields.pages = {
        'nb-NO': article.pages
      };
    }

    if (typeof article.myPageCategories !== 'undefined') {
      result.fields.myPageCategories = {
        'nb-NO': article.myPageCategories
      };
    }

    if (typeof article.fromDate !== 'undefined') {
      result.fields.fromDate = {
        'nb-NO': article.fromDate ? article.fromDate.toISOString() : null
      };
    }

    if (typeof article.toDate !== 'undefined') {
      result.fields.toDate = {
        'nb-NO': article.toDate ? article.toDate.toISOString() : null
      };
    }

    // Dealer links:
    if (typeof article.dealers !== 'undefined') {
      result.fields.dealers = {
        'nb-NO': article.dealers ? article.dealers.map(createEntryLink) : null
      };
    }

    // CTA
    if (typeof article.ctaForm !== 'undefined') {
      result.fields.ctaForm = {
        'nb-NO': article.ctaForm
      };
    }
    if (typeof article.ctaFormExt !== 'undefined') {
      result.fields.ctaFormExt = {
        // Note: Will clear the field if another form type is selected
        'nb-NO': (article.ctaForm === 'external' && article.ctaFormExt) ? createEntryLink(article.ctaFormExt) : null
      };
    }
    if (typeof article.ctaTitle !== 'undefined') {
      result.fields.ctaTitle = {
        'nb-NO': article.ctaTitle
      };
    }
    if (typeof article.ctaText !== 'undefined') {
      result.fields.ctaText = {
        'nb-NO': article.ctaText
      };
    }
    if (typeof article.ctaUrl !== 'undefined') {
      result.fields.ctaUrl = {
        'nb-NO': article.ctaUrl
      };
    }
    if (typeof article.ctaButtonText !== 'undefined') {
      result.fields.ctaButtonText = {
        'nb-NO': article.ctaButtonText
      };
    }
    if (typeof article.ctaAlign !== 'undefined') {
      result.fields.ctaAlign = {
        'nb-NO': article.ctaAlign
      };
    }

    if (typeof article.criticalBannerArticle !== 'undefined') {
      result.fields.criticalBannerArticle = {
        'nb-NO': article.criticalBannerArticle
      };
    }
    if (typeof article.criticalBannerText !== 'undefined') {
      result.fields.criticalBannerText = {
        'nb-NO': article.criticalBannerText
      };
    }

    if (typeof article.motorforum !== 'undefined') {
      result.fields.motorforum = {
        'nb-NO': article.motorforum
      };
    }

    return result;
  }
};
